import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { getCourseListApi } from '../../Api/ClientServices'
import Button from '../Button/Button'
import Style from './UserPanelAllCourses.module.css'
import ReactLoading from 'react-loading';
import { Link } from 'react-router-dom'

const UserPanelAllCourses = () => {
    const[list,setList]=useState()

    useEffect(()=>getAllCourse(),[])

    const getAllCourse=async()=>{
        const data=await getCourseListApi()
        setList(data.courses)
    }

    let loadingHandler=null
    if(list===undefined){
        loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
        <ReactLoading type={'cylon'} color={'#096CCC'} />
        <p style={{marginTop:'3rem',color:"#fff"}}>لطفا منتظر باشید</p>
      </div>
    }
    else{
        loadingHandler=list.map(item=>{
            return(
                <li className={Style.CourseHolder}>
                    <p><FontAwesomeIcon icon={faChalkboardTeacher}/>{item.name} </p>
                    <Link to={`../course/${item.id}`}><Button Value='انتقال به صفحه دوره' ClassBtn={'buyBtn'}/></Link>
                </li> 
            )
        })
    }
    return (
        <ul className='pageHolder' style={{padding:0}}>
           {loadingHandler} 
        </ul>
    )
}

export default UserPanelAllCourses
